exports.LocationsPageView = require('./LocationsPageView').default;
exports.LocationCreatePageView = require('./LocationCreatePageView').default;
exports.LocationUpdatePageView = require('./LocationUpdatePageView').default;
